export const formatPercent = (percent: number): string => {
  return new Intl.NumberFormat('de-DE', {
    style: 'percent',
    maximumFractionDigits: 2,
  }).format(percent / 100);
};
